import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1200Model } from '../kymw1200.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * サイクル設定表示条件情報登録サービス
 * @export RegistCycleDispConditionService
 * @class RegistCycleDispConditionService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistCycleDispConditionService extends PlessJsonResponderSub<null> {
  model: KYMW1200Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistCycleDispConditionService
   */
  private getBody(): PlessRequest {
    const param = {
      DispMedium: this.model.mediumType,
      DispBuyer: this.model.buyerCode,
      DispCoop: this.model.coopCode,
      DispDiv: this.model.switchType,
      StartOrderCode: this.model.orderCodeFrom,
      EndOrderCode: this.model.orderCodeTo,
    };

    return new PlessRequest({
      parameter: param,
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param f
   * @memberof RegistCycleDispConditionService
   */
  execute(model: KYMW1200Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('registCycleDispCondition', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof RegistCycleDispConditionService
   */
  success() {
    if (this.calbak) this.calbak();
  }
}
